// Actions pertaining to reply and forward of a MsgThreadItem

import React from 'react';
import { func, object, string } from 'prop-types';

import MessageThreadButton from '../MessageThreadButton';

import cx from 'classnames';
import s from './MessageThreadActions.css';


const MessageThreadActions = ({ ...props }) =>
  <nav className={cx(s.component, props.className)}>
    {props.authenticatedPreferences.messageReplyEnabled && props.canReply && 
    <MessageThreadButton
      name="Reply"
      className={s.button}
      handleMsgFormDisplay={props.handleMsgFormDisplay}
    />
    }
    <MessageThreadButton
      name="Forward"
      className={s.button}
      handleMsgFormDisplay={props.handleMsgFormDisplay}
    />
  </nav>;

MessageThreadActions.propTypes = {
  authenticatedPreferences: object,
  className: string,
  handleMsgFormDisplay: func,
};

export default MessageThreadActions;



// WEBPACK FOOTER //
// ./src/components/Pages/Messages/MessageThreadActions/MessageThreadActions.js